// extracted by mini-css-extract-plugin
export var boldText = "_5r-4";
export var checkboxContainer = "_5r-6";
export var closeIcon = "_5r-i";
export var container = "_5r-0";
export var drawer = "_5r-8";
export var drawerContent = "_5r-9";
export var extraSmallText = "_5r-5";
export var fulfillmentGroupTable = "_5r-e";
export var largeText = "_5r-3";
export var loadingSpinnerContainer = "_5r-j";
export var mediumText = "_5r-2";
export var narrow = "_5r-f";
export var notificationLink = "_5r-l";
export var packageCheckIconContainer = "_5r-7";
export var slideoutHeaderActions = "_5r-g";
export var slideoutHeaderActionsShifted = "_5r-h";
export var slideoutHeaderContainer = "_5r-a";
export var slideoutModal = "_5r-c";
export var stickyHeaderWrapper = "_5r-b";
export var table = "_5r-k";
export var tableContainer = "_5r-d";
export var tertiaryText = "_5r-1";